
<ion-content>
  @if (globalService.isExpe) {
  <ion-modal [isOpen]="expeModal()" id="tmp-modal">
    <ng-template>
      <app-tmp-dashboard></app-tmp-dashboard>
      <button (click)="expeModal.set(false)">Accéder au chat</button>
    </ng-template>
  </ion-modal>
  }
  @if (!globalService.isMobile) {
    <div id="chat-list-container">
      <ion-searchbar id="chat-search" type="text" placeholder="Rechercher une conversation" (ionInput)="searchChat($event.target.value)"></ion-searchbar>
      <div id="list-container">
        <ul #scrollContainer class="chat-list" [class.is-open]="isChatListOpen" [ngClass]="globalService.isFirefox ? 'scrollbar-auto' : 'scrollbar-thin'">
          @for (chat of chats(); track $index) {
            <div #chatItem class="chat-item" [ngClass]="{'active-chat': chat.id === currentChatId(), 'hide': chat.context === 'init', 'green': accentColor() === 'green', 'blue': accentColor() === 'blue', 'yellow': accentColor() === 'yellow', 'purple': accentColor() === 'purple'}" #param (click)="setDisplayedChat($index, chat.id, chat.context)">                        
              <div class="chat-infos">
                <div class="chat-type">
                  <p>{{ chat.type }}</p>
                </div>
                <div class="chat-title" >
                  <p>Conversation  n°{{chats().length - ($index + 0)}}</p>
                  <p class="date">
                    @if (chat.date.includes('/')) {
                        Débuté le <span>{{chat.date}}</span> à <span>{{chat.time}}</span>
                    }
                    @else {
                        Débuté le @if (chat.date){<span>{{ chat.date | date:'dd/MM/YYYY' }}</span>} à
                        @if (chat.date){<span>{{ chat.date | date:'HH:mm':'+' }}</span>}
                    }
                    <!-- <span>Débuté le {{ chat.date }}</span> -->
                  </p>
                </div>
              </div>
    
              <!-- <ion-button class="chat-params-btn" (click)="openEditModal(true, $index, 'Conversation  n°' + (chats().length - ($index + 0)))">
                <ion-icon name="create-outline"></ion-icon>
              </ion-button>

              <ion-button class="chat-params-btn" (click)="openConfirmModal($index, 'Conversation  n°' + (chats().length - ($index + 0)))">
                <ion-icon name="trash-outline"></ion-icon>
              </ion-button> -->
            </div>
          }
        </ul>
  
        <ion-button id="new-chat" (click)="addChat('')">
          Nouvelle conversation
        </ion-button>
      </div>
    </div>
  } @else {
    <ion-button id="chat-list-btn" (click)="openChatList()">
      <div class="btn-content">
        <span>Liste des chats</span>
        <ion-icon aria-hidden slot="end" name="chevron-down-outline" [class.is-open]="isChatListOpen"></ion-icon>
      </div>
    </ion-button>
    
    <div #scrollContainer class="chat-list" id="chat-list-container" [class.is-open]="isChatListOpen" [class.is-close]="isChatListOpen === false" [class.hide]="hideChatList">
      <ion-searchbar id="chat-search" type="text" placeholder="Rechercher une conversation" (ionInput)="searchChat($event.target.value)"></ion-searchbar>
      <ul [ngClass]="globalService.isFirefox ? 'scrollbar-auto' : 'scrollbar-thin'">
        @for (chat of chats(); track $index) {        
          <div class="chat-item" [ngClass]="{'active-chat': chat.id === currentChatId(), 'hide': chat.context === 'init', 'green': accentColor() === 'green', 'blue': accentColor() === 'blue', 'yellow': accentColor() === 'yellow', 'purple': accentColor() === 'purple'}">
            <div class="chat-infos" (click)="setDisplayedChat($index, chat.id, chat.context)">
              <div class="chat-type">
                <p>{{ chat.type }} </p>
              </div>
              <div class="chat-title" >
                <p>Conversation n°{{chats().length - ($index + 0)}}</p>
                <p class="date">
                  <span>{{ chat.date }}</span>
                </p>
              </div>
            </div>
          
            <ion-button aria-label="Paramètres de chat" class="chat-params-btn">
              <ion-icon name="ellipsis-vertical"></ion-icon>
            </ion-button>
          </div>
        }
      </ul>
      <ion-button id="new-chat" (click)="addChat('')">
        Nouvelle conversation
      </ion-button>
    </div>
  }

  <!-- <div id="chat-container" [style.background-color]="'var(--iacdp-' + accentColor() + '-3)'"> -->
  <div id="chat-container">
    <app-chat-modal [currentChat]="currentChatId()" [currentContext]="context()" (chatContext)="getChatContext($event)"></app-chat-modal>
  </div>

  <ion-modal [isOpen]="editModal()" (willDismiss)="editModal.set(false)" id="edit-modal">
    <ng-template>
        <header>
            <h4>
              {{ isEdit ? 'Modifier le chat' : 'Nouveau chat' }}
            </h4>
        </header>
        <form enctype="multipart/form-data" action="" (ngSubmit)="onSubmit()">
          <div class="input-container">
            <ion-label for="name">
              {{ isEdit ? 'Nouveau nom' : 'Nom du chat' }}
            </ion-label>
            <ion-input id="name" type="text" [formControl]="setChatTitle"></ion-input>
          </div>
          <ion-button id="modify-chat-button" type="submit" [disabled]="!setChatTitle.value" [ngClass]="{'green': accentColor() === 'green', 'blue': accentColor() === 'blue', 'yellow': accentColor() === 'yellow', 'purple': accentColor() === 'purple'}">
            {{ isEdit ? 'Valider' : 'Créer' }}
          </ion-button>
        </form>
    </ng-template>
  </ion-modal>

  <app-confirm-modal [isOpen]="confirmModal()" [content]="removedChatTitle" (confirm)="deleteChat()"></app-confirm-modal>
</ion-content>